import {DetailDialog, DetailDialogProps} from "../../../../components/DetailDialog";
import {EQUIPMENT_URLS, URL_PARAMS, DISP_MODE} from "../../../../constants/constants";

export interface HandDetailDialogProps extends Omit<DetailDialogProps, 'title' | 'src'> {
  handId: string,
}

export function HandDetailDialog(props: HandDetailDialogProps) {
  // console.log('Hand Detail Dialog', props.handId);
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <DetailDialog {...props} title='ハンド詳細' src={`${EQUIPMENT_URLS.HAND_DETAIL.URL}/${props.handId}?${URL_PARAMS.DISP_MODE}=${DISP_MODE.POPUP}`}/>
  )
}
